import React, { Component } from "react";
import { Helmet } from "react-helmet";
import "../RegisterForm/AboutYourself/style.css";
import Form from "react-bootstrap/Form";
import Button from "components/Button/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import logo from "Assets/loginLogo.svg";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import axios from "axios";
import { getQueryString } from "utils/Helper";
import { origin } from 'utils/Helper';
//import { environment, myHeaders_With_Cache_Control, HeaderConfig, myHeaders_Autorized, user_API } from "Api/Api";
import { myHeaders_With_Cache_Control, myHeaders_Autorized, user_API } from "Api/Api";
import { NavLink } from "react-router-dom";
import { local_routes } from "utils/Routes";
//const locationSearchAPI = environment.location_Search;

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTokenValid: null,
      value: "",
      loading: true,
      validated: false,
      ModalLoader: false,
      //city_Data: [],
      //city: null,
      hidden: true,
      hiddenNew: true,
      InvalidResendMsg: 0,
      invalidpassword: 0,
      clicked: true,
      clickedNew: true,
      newpassword: '',
      confirmpassword: ''
    };
    this.toggleShow = this.toggleShow.bind(this);
    this.toggleShowpassword = this.toggleShowpassword.bind(this);
  }
  
  componentDidMount = async function () {
    document.body.style.background = "#343E47";
    const resetpassword_token = getQueryString('resetpassword_token');
    //let tempArr = [];
    try {
      //let response = await axios.get(`${user_API}/resetPassword/${resetpassword_token}`, myHeaders_With_Cache_Control);
      await axios.get(`${user_API}/resetPassword/${resetpassword_token}`, myHeaders_With_Cache_Control);
      this.setState({ isTokenValid: true, loading: false });
      //console.log("YO",response);
      //if (response.data.message && response.data.message === "success") {
        // valid token!
      //} else {
        // invalid token!
      //}
    } catch (err) {
      //console.error("resepassword invalid token",err);
      this.setState({ isTokenValid: false, loading: false });
    }
    // JBB - 12/13/2019 - we want to check the token validity to let user know it has expired
    
    // JBB - 12/13/2019 - why was this code here? leftover from another page probably
    /*
    axios
      .get(
        `${locationSearchAPI}?coordinates_lat=0&coordinates_lon=0&radius=1000`,
        HeaderConfig
      )
      .then(response => {
        let minified_res = response.data.search_query_results;
        minified_res.forEach(function (element) {
          tempArr.push(element.entity_info);
        });
        this.setState({ city_Data: tempArr, loading: false });
        if (this.state.city_Data !== null) {
          let city_Data = this.state.city_Data[0].city_name;
          this.setState({ city: city_Data });
        }
      })
      .catch(error => {
      });
    */
  }

  // password validation
  myPasswordChangeHandler = event => {
    if (event.target.id === "oldPasswordName") {
      this.setState({ newpassword: event.target.value });
    } else if (event.target.id === "newPasswordName") {
      this.setState({ confirmpassword: event.target.value });
    }
  };

  handleSubmitData = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    else if (form.checkValidity() !== false) {
      event.preventDefault();
      const { newpassword } = this.state;
      this.setState({ ModalLoader: true })
      const resetpassword_token = getQueryString('resetpassword_token');
      let passwordData = { "password": newpassword }
      if (this.state.newpassword === this.state.confirmpassword) {
        axios.post(`${user_API}/resetPassword/${resetpassword_token}`, JSON.stringify(passwordData), myHeaders_Autorized)
          .then((response) => {
            this.setState({ ModalLoader: false, InvalidResendMsg: 0 })
            window.location.href = `${origin}/login`;
          })
          .catch((error) => {
            this.setState({ ModalLoader: false, InvalidResendMsg: 1, })
          });
      }
      else {
        this.setState({ ModalLoader: false, invalidpassword: 1 })
      }
    }
    this.setState({ validated: true })
  };

  // Password Hide and Show
  toggleShow() {
    this.setState({ hidden: !this.state.hidden, clicked: !this.state.clicked });
  }
  toggleShowpassword() {
    this.setState({ hiddenNew: !this.state.hiddenNew, clickedNew: !this.state.clickedNew });
  }
  // Showing valid and invalid messages
  messageResend = () => {
    const { InvalidResendMsg } = this.state;
    return (
      <div style={{ display: this.state.InvalidResendMsg === 0 ? "none" : null }} className="Invalid-section resend-msg">
        {
          InvalidResendMsg === 0 ?
            <span className="Valid-Msg">Password Updated Successfully</span>
            :
            <span className="Invalid-Msg">Update Password Link has expired. Please request another password update email.</span>
        }
      </div>
    )
  }
  // ResetPassword data
  ResetPasswordChip = () => {
    return (
      <div className="Login-body">
        <p className="pad-bot10">Update Password</p>
        <div className="Form-section">
          {this.state.isTokenValid ?
          
            <Form
              noValidate
              validated={this.state.validated}
              onSubmit={this.handleSubmitData}
            >
              <Form.Row>
                <Form.Group as={Col} md="12" controlId="oldPasswordName">
                  <Form.Label className="pad-bot5">NEW PASSWORD</Form.Label>
                  <Form.Control
                    required
                    type={this.state.hidden ? "password" : "text"}
                    value={this.state.newpassword}
                    onChange={this.myPasswordChangeHandler}
                    placeholder="Enter your new password"
                  />
                  <div onClick={this.toggleShow} className="password-show">
                    {this.state.clicked ? <i className="fa fa-eye"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}
                  </div>
                </Form.Group>
              </Form.Row>
  
              <Form.Row>
                <Form.Group as={Col} md="12" controlId="newPasswordName">
                  <div className="city-Dropdown">
                    <Form.Label className="pad-bot5">CONFIRM PASSWORD</Form.Label>
                    <Form.Control
                      type={this.state.hiddenNew ? "password" : "text"}
                      value={this.state.confirmpassword}
                      onChange={this.myPasswordChangeHandler}
                      required
                      placeholder="Confirm your password"
                    />
                    <div onClick={this.toggleShowpassword} className="password-show">
                      {this.state.clickedNew ? <i className="fa fa-eye"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}
                    </div>
                  </div>
                </Form.Group>
              </Form.Row>
              {this.state.ModalLoader === false ? (
                <div>
                  {this.state.newpassword === this.state.confirmpassword ?
                    this.messageResend()
                    :
                    <React.Fragment>
                      {
                        this.state.invalidpassword === 1 &&
                        <div className="Invalid-section resend-msg">
                          <span className="Invalid-Msg">Passwords do not match</span>
                        </div>
                      }
                    </React.Fragment>
                  }
                  <Button theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5">
                    Update
              </Button>
                </div>
              ) : (
                  <ActivityIndicator theme="button-Status-Loader" />
                )}
            </Form>
            :
            <div>
              <span style={{ color:"red" }}>Invalid or Expired Update Password Token</span><br/>
              <NavLink to={local_routes.sendresetpasswordemail}>
                Request a new update password email
              </NavLink>
            </div>
          }
        </div>
      </div>
    );
  };

  render() {
    if (this.state.loading) {
      return <ActivityIndicator theme="spinner" />;
    } else {
      return (
        <React.Fragment>
          <Helmet>
            <title>PechaKucha Update Password</title>
            <meta name="robots" content="noindex, nofollow" />
          </Helmet>
          <div className="Login-grid pad-top100">
            <Row className="nomargin">
              <Col lg={12}>
                <div className="flex-center logo-container">
                  <a href="/"><img
                    src={logo}
                    alt="img"
                    className="img-fluid navbar-brand img-logo"
                  /></a>
                </div>
                <div className="Login-Form">
                  {this.ResetPasswordChip()}
                </div>
              </Col>
            </Row>
          </div>
        </React.Fragment>
      );
    }
  }
}

export default ResetPassword;
